<template>
  <div class="eventmap-page__search" v-if="modalState === 'normal'">
    <div class="eventmap-page__search-input">
      <FrontendTextInput
        v-model="searchText"
        id="search-text"
        :max="500"
        hideCounter
        placeholderIcon="far fa-search"
        placeholder="Find"
        @focus="modalState = 'expanded'"
      />
    </div>
  </div>
  <div
    v-if="modalState === 'expanded'"
    class="eventmap-page__search eventmap-page__search--open"
  >
    <EventmapLocationSearchList
      v-model:searchText="searchText"
      v-model:routeEnd="routeEnd"
      v-model:modalState="modalState"
      v-model:selectedLocation="selectedLocation"
      :locations="eventmap?.expanded_locations || []"
      searchInputPlaceholder="Find"
      :mode="mode"
      autofocus
      showCloseSearchButton
      showNavigationButton
      showPreviewButton
      @onLocationSelected="(location) => $emit('onLocationSelected', location)"
    />
  </div>
</template>

<script setup>
import { defineModel } from 'vue';

defineProps({
  mode: {
    type: String,
    default: 'platform',
  },
});

const searchText = defineModel('searchText', { type: String, default: '' });

const modalState = defineModel('modalState', { type: String, default: 'normal' });

const eventmap = defineModel('eventmap', { type: Object, default: () => ({}) });

const selectedLocation = defineModel('selectedLocation', { type: Object, default: null });

const routeEnd = defineModel('routeEnd', { type: Object, default: null });

defineEmits(['onLocationSelected']);
</script>
